import React from 'react';

import cs from 'classnames';
import {withRouter, WithRouterProps} from 'react-router';

function isLeftClickEvent(event: {button?: number}): boolean {
  return event.button === 0;
}

type EventProp = {
  metaKey: boolean;
  altKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
};

function isModifiedEvent(event: EventProp): boolean {
  return event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
}

type Props = WithRouterProps & {
  to: string;
  activeTo: string;
  inactiveClassName: string;
  activeClassName: string;
  children: any;
  className: string;
  href?: string;
};

export const ToggleActiveLink = withRouter(
  ({
    inactiveClassName = '',
    activeClassName = '',
    className = '',
    to,
    activeTo,
    router,
    href,
    children,
  }: Props) => {
    function handleClick(event) {
      if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
      event.preventDefault();
      router.push(resolveToLocation(router, to, activeTo));
    }

    if (router) {
      const isActive = router.isActive(to);
      href = resolveToLocation(router, to, activeTo);
      className = cs(className, {
        [activeClassName]: isActive,
        [inactiveClassName]: !isActive,
      });
    }

    return (
      <a className={className} href={href} onClick={handleClick}>
        {children}
      </a>
    );
  }
);

function resolveToLocation(router, to, activeTo) {
  return router.isActive(to) ? activeTo : to;
}
